import {commonActions} from '../../actions/commonActions';
import {stateSetList} from '../../actions/areaActions';
import {connect} from 'react-redux';
import List from '../../components/area/StateList';
import {API_FETCH} from '../../services/FetchService';



const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        API_FETCH.get('area/state',{params: value}).then(list => {
            dispatch(stateSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }
}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.area.stateList,
        common       : state.common
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);